





















































































































































































































































import Component from "vue-class-component";
import Vue from "vue";
import OrderItem from "./module/orderItem.vue";
import Radio from "./module/radio.vue";
import InfoConfirm from "./module/infoConfirm.vue";
import moduleStore from "./store/index";
import { Watch } from "vue-property-decorator";
import { Toast } from "vant";
import {
  debounce,
} from '@/utils/util'
import {judgeDeviceType} from '@/utils/device'
const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export enum InvoiceLin {
  ORDINARY_ELECTRONIC = 0,
  SPECIAL = 1,
}
export const InvoiceLinLabels = {
  [InvoiceLin.ORDINARY_ELECTRONIC]: "电子发票",
  [InvoiceLin.SPECIAL]: "专用发票",
};
export enum headType {
  ENTERPRISE = 0,
  PERSON = 1,
}
export const headTypeLabels = {
  [headType.ENTERPRISE]: "企业单位",
  [headType.PERSON]: "个人/非企业单位",
};
@Component({
  components: { OrderItem, Radio, InfoConfirm },
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames,
})
export default class indexPage extends Vue {
  InvoiceLin = InvoiceLin;
  InvoiceLinLabels = InvoiceLinLabels;
  headType = headType;
  headTypeLabels = headTypeLabels;
  isExtend = false;
  subDis = true;
  emailRegex=emailRegex
  showFooter=true
  formData: any = {
    invoiceLine: InvoiceLin.ORDINARY_ELECTRONIC,
    headType: headType.ENTERPRISE,
    userName: "",
    buyerName: "",
    buyerTaxNum: "",
    buyerAddress: "",
    buyerTel: "",
    buyerBank: "",
    buyerAccount: "",
    deliveryName: "",
    deliveryPhone: "",
    deliveryAddress: "",
    email: "",
  };
  docmHeight = document.documentElement.clientHeight  //默认屏幕高度
  showHeight = document.documentElement.clientHeight   //实时屏幕高度
  mounted() {
    // ;(window as any).setKeyboardHeight = debounce(
    //   this.setKeyboardHeight.bind(this),
    //   50,
    //   false
    // ) // 防抖，只获取最后一次的高度，避免页面不断重新布局
    window.addEventListener('resize', ()=>{
      this.showHeight = document.body.clientHeight;
    }, true);
  }
  setKeyboardHeight(value){
    this.showFooter = value>0? false: true
  }
  @Watch("showHeight", { deep: true, immediate: true })
  onShowHeight(val: string, oldVal: string) {
    if(judgeDeviceType.isIOS){
      if(this.docmHeight > this.showHeight){
        this.showFooter=false
      }else{
        this.showFooter=true
      }
    }
  }
  @Watch("formData", { deep: true, immediate: true })
  onChildChanged(val: string, oldVal: string) {
    this.validate();
  }
  buyerTaxNumInput(val){
    this.formData.buyerTaxNum =  val.replace(/\s/g,'').replace(/(.{4})/g,"$1 ")
  }
  async validate() {
    let arr = [];
    if (this.formData.invoiceLine == InvoiceLin.SPECIAL) {
      // 专用发票
      arr = [
        "buyerName",
        "buyerTaxNum",
        "buyerAddress",
        "buyerTel",
        "buyerBank",
        "buyerAccount",
        "deliveryName",
        "deliveryPhone",
        "deliveryAddress",
        "email",
      ];
    } else if (this.formData.headType == headType.ENTERPRISE) {
      // 企业
      arr = ["buyerName", "buyerTaxNum", "email"];
    } else {
      // 个人
      arr = ["userName", "email"];
    }
    const arrFilter = arr
      .map((vo) => {
        return this.formData[vo];
      })
      .filter((vo) => vo);
    this.subDis = arrFilter.length == arr.length ? false : true;
  }
  resetValidation(arr) {
    (this as any).$refs.form.resetValidation(arr);
  }
  submit() {
    (this as any).$refs.form?.submit();
    // (this as any).$refs.form?.validate(); //动态表单有问题
    // (this as any).$refs.infoConfirm?.setShow(true);
  }
  onSubmit() {
    console.log("onSubmit");
    (this as any).$refs.infoConfirm?.setShow(true);
  }
  onFailed(errinfo) {
    console.log("onFailed", errinfo);
  }
  async sureSubmit() {
    console.log(123);
    
    let params: any = {};
    if (this.pageState.isAll) params.allWaitInvoice = true;
    else params.ids = this.pageState.orderIds;
    (this as any).$refs.infoConfirm?.setShow(false);
    const res = await (this as any).submitInvoice({
      ...params,
      ...this.formData,
      buyerName:
        this.formData.headType == headType.PERSON
          ? this.formData.userName
          : this.formData.buyerName,
      buyerTaxNum: this.formData.buyerTaxNum.replace(/\s/g,''),
      invoiceLine: this.InvoiceLin[this.formData.invoiceLine],
      headType: this.headType[this.formData.headType],
      amount: parseFloat(this.pageState.totalMoney).toFixed(2),
    });
    if (res.code == 200) {
      const data = res.data;
      this.$router.push(
        `/order/success?invoiceLine=${this.formData.invoiceLine}&merchant=${data.mchIdKind}`
      );
    } else {
      Toast({
        type: "fail",
        message: res.message,
      });
    }
  }
}
